<template>
  <div>
    <p>A-PZN
      <button @click="addRecord()" type="button" class="btn btn-default btn-xs">Добавить код
      </button>
    </p>
    <template v-for="(r,i) in records">
      <div class="input-group" v-if="r.alias === 'apzn' && !r.to_delete">
        <input type="text" v-model="r.text_value" class="form-control">
        <div class="input-group-append">
          <button @click="removeRecord(i)" type="button" class="btn btn-outline-danger"><i
            class="icon-fa icon-fa-trash"/></button>
        </div>
      </div>
    </template>
  </div>
</template>
<script>

export default {
  props: ['records'],
  data() {
    return {}
  },
  methods: {
    addRecord() {
      console.log('add');
      this.records.push({
        group_alias: 'manufacturer',
        alias: 'apzn',
        type: 'text',
        text_value: '',
        to_delete: false,
      });
    },
    removeRecord(index) {
      this.$set(this.records[index], 'to_delete', true);
    }
  }
}

</script>
